
import { Options, Vue } from 'vue-class-component';
import { InjectReactive } from 'vue-property-decorator';
import OrderActivity from '@/modules/order/common/classes/OrderActivity.class';
import { orderModule } from '@/modules/order/orderModule.vuex-module';
import { Time } from '@/common/models/Time.model';
import moment from 'moment';

@Options({
	name: 'TimeSwapConfirmView',
})
export default class TimeSwapConfirmView extends Vue {
	@InjectReactive() time?: Time;
	loading = false;
	error: string | null = null;
	pendingSnapshot: Time | null = null;

	get source(): OrderActivity | null {
		return orderModule.openActivity;
	}
	get target(): OrderActivity | null {
		return orderModule.swapTarget;
	}
	get pending(): Time | null {
		return this.target?.pendingTime ?? this.pendingSnapshot;
	}
	describe(t: Time | null | undefined): string {
		if (!t) return '';
		const date = moment(t.AppointmentDate).format('ddd, MMM D, YYYY');
		return t.AppointmentTypeKey == 1 ? `${date} @ ${t.DisplayName}` : date;
	}
	get from(): string {
		return this.describe(this.time);
	}
	get to(): string {
		if (!this.pending) return '';
		const date = moment(this.target?.selectedDate ?? this.pending.AppointmentDate).format('ddd, MMM D, YYYY');
		return this.pending.AppointmentTypeKey == 1 ? `${date} @ ${this.pending.DisplayName}` : date;
	}
	get priceDifference(): number {
		if (!this.pending || !this.time) return 0;
		return Math.round((this.pending.SubTotal - this.time.Cost) * 100) / 100;
	}
	mounted(): void {
		// The swap screen must be passed through first (deep links land back on the booking).
		if (!this.target?.pendingTime) this.$router.replace({ name: 'OrderTime' });
	}
	async confirm(): Promise<void> {
		if (!this.target) return;
		this.loading = true;
		this.error = null;
		this.pendingSnapshot = this.target.pendingTime;
		const errors = await orderModule.swapActivity(this.target);
		this.loading = false;
		if (errors) {
			this.error = errors.join('<br/>');
			return;
		}
		const ctx = orderModule.swapContext;
		if (!ctx) return;
		const balance = orderModule._activeOrder?.balance ?? 0;
		if (!ctx.committed) {
			// Pending until the price difference is paid or refunded, exactly like a reschedule.
			this.$router.push({ name: balance > 0 ? 'OrderTimePayment' : 'OrderTimeRefund' });
			return;
		}
		// Committed: reload onto the new booking; a lower price with no refund option stays as an order credit.
		const credit = balance < 0 ? `&credit=${Math.abs(balance).toFixed(2)}` : '';
		const base = `${window.location.origin}/manage/${this.$route.params.clientLocationKey}/${this.$route.params.orderKey}`;
		window.location.assign(ctx.newOrderEntityTimeKey ? `${base}/edit/${ctx.newOrderEntityTimeKey}?success=true${credit}` : `${base}?success=true`);
	}
}
